import {
  Flame, Droplets, Sparkles, Timer, UtensilsCrossed, Globe,
  Check, ChevronLeft, CheckCircle2, ArrowLeft, Clock,
  Lightbulb, Pause, NotebookPen, Slice, Cloud, Snowflake,
  Egg, CookingPot, Salad, Shuffle, CakeSlice, Gauge,
  Play, ChefHat, Plus, Minus, Trash2,
  Mail, Lock, LogIn, LogOut, UserPlus,
  Home, AlertTriangle, Link as LinkIcon,
  Menu, X, ClipboardCopy, Share2,
  Leaf, Milk, Beef, Package, ShoppingBag, ShoppingCart, Wand2,
  ExternalLink, RefreshCw, MessageSquare, Search, ChevronDown, ChevronUp,
  Download, Square, CheckSquare, ChevronRight, List, DollarSign,
  Moon, Sun, Pencil, Monitor, Trophy, CalendarDays,
} from 'lucide-react';
import { Icon } from '@chakra-ui/react';
import React from 'react';

const ICON_MAP = {
  'technique.saute': Flame,
  'technique.boil': Droplets,
  'technique.bake': Sparkles,
  'technique.grill': Flame,
  'technique.fry': CookingPot,
  'technique.roast': Flame,
  'technique.simmer': Cloud,
  'technique.steam': Cloud,
  'technique.toss': Salad,
  'technique.mix': Shuffle,
  'technique.chop': Slice,
  'technique.rest': Pause,
  'technique.chill': Snowflake,
  'technique.whisk': Egg,
  'technique.fold': CakeSlice,
  'meta.time': Timer,
  'meta.servings': UtensilsCrossed,
  'meta.cuisine': Globe,
  'difficulty.easy': Gauge,
  'difficulty.medium': Gauge,
  'difficulty.hard': Gauge,
  'ui.tip': Lightbulb,
  'ui.pause': Pause,
  'ui.play': Play,
  'ui.notes': NotebookPen,
  'ui.check': Check,
  'ui.checkCircle': CheckCircle2,
  'ui.back': ArrowLeft,
  'ui.chevronLeft': ChevronLeft,
  'ui.clock': Clock,
  'ui.chef': ChefHat,
  'ui.plus': Plus,
  'ui.minus': Minus,
  'ui.moon': Moon,
  'ui.sun': Sun,
  'ui.delete': Trash2,
  'ui.mail': Mail,
  'ui.lock': Lock,
  'ui.login': LogIn,
  'ui.logout': LogOut,
  'ui.userPlus': UserPlus,
  'ui.kitchen': Home,
  'ui.warning': AlertTriangle,
  'ui.link': LinkIcon,
  'ui.menu': Menu,
  'ui.close': X,
  'ui.shoppingCart': ShoppingCart,
  'ui.wand': Wand2,
  'ui.clipboardCopy': ClipboardCopy,
  'ui.share': Share2,
  'shop.produce': Leaf,
  'shop.dairy': Milk,
  'shop.meat': Beef,
  'shop.spice': Flame,
  'shop.pantry': Package,
  'shop.other': ShoppingBag,
  'ui.externalLink': ExternalLink,
  'ui.refresh': RefreshCw,
  'ui.message': MessageSquare,
  'ui.search': Search,
  'ui.chevronDown': ChevronDown,
  'ui.chevronUp': ChevronUp,
  'ui.download': Download,
  'ui.checkbox': Square,
  'ui.checkboxChecked': CheckSquare,
  'ui.chevronRight': ChevronRight,
  'ui.list': List,
  'ui.dollarSign': DollarSign,
  'ui.edit': Pencil,
  'ui.monitor': Monitor,
  'ui.trophy': Trophy,
  'ui.calendar': CalendarDays,
  'ui.x': X,
} as const;

export type IconName = keyof typeof ICON_MAP;

interface AppIconProps {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export const AppIcon: React.FC<AppIconProps> = ({ name, size = 16, color, strokeWidth = 2 }) => {
  const LucideComponent = ICON_MAP[name];
  return <Icon as={LucideComponent} boxSize={`${size}px`} color={color} strokeWidth={strokeWidth} />;
};

export { ICON_MAP };
